// extracted by mini-css-extract-plugin
export var actionText = "_sm-4";
export var container = "_sm-0";
export var leftSection = "_sm-1";
export var rightSection = "_sm-2";
export var settingsButton = "_sm-6";
export var settingsIcon = "_sm-7";
export var shortcut = "_sm-5";
export var shortcutGroup = "_sm-3";